import { BillOfMaterialsType } from 'src/types/billOfMaterials';

export const formatData = (data: BillOfMaterialsType[]) =>
    data.map((item) => ({ ...item, FINAL_PRODUCT_SKU: item.FINAL_PRODUCT?.SKU }));
